import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";

import { USER_INTERACTION_DATA_ATTRIBUTE } from "@shared/constants";

interface ButtonClassProps extends React.HTMLAttributes<HTMLElement> {
  chevron?: boolean;
  color?: "action" | "primary-light" | "primary" | "secondary";
  componentStyle?: "default" | "inverted";
  iconRight?: React.ReactNode;
  size?: "default" | "small";
  variant?: "transparent" | "outlined" | "solid";
}

export interface CommonButtonProps extends ButtonClassProps {
  text?: string;
  [USER_INTERACTION_DATA_ATTRIBUTE]?: string;
}

export function createButtonClassNames({
  className,
  color,
  componentStyle,
  iconRight,
  size,
  variant,
}: ButtonClassProps) {
  return clsx(
    {
      [`financial-education-button`]: true,
      [`financial-education-button--is-action`]: !color || color === "action",
      [`financial-education-button--is-neutral`]: color === "primary-light",
      [`financial-education-button--is-primary`]: color === "primary",
      [`financial-education-button--is-secondary`]: color === "secondary",
      [`financial-education-button--is-transparent`]: variant === "transparent",
      [`financial-education-button--is-outlined`]: variant === "outlined",
      [`financial-education-button--is-solid`]: !variant || variant === "solid",
      [`financial-education-button--is-small`]: size === "small",
      [`financial-education-button--has-icon-right`]: iconRight,
      [`financial-education-button--is-inverted`]:
        componentStyle === "inverted",
    },
    className,
  );
}

export function determineIcon({
  chevron,
  iconRight,
}: ButtonClassProps): React.ReactNode {
  if (!chevron && !iconRight) return;

  if (iconRight) {
    return iconRight;
  }
  if (chevron) {
    return <FontAwesomeIcon icon={faChevronRight} />;
  }
  return;
}

interface ButtonContentProps {
  icon?: React.ReactNode;
  text: string;
  iconLeftBandaid?: boolean;
}

export function ButtonContent({
  icon,
  text,
  iconLeftBandaid,
}: ButtonContentProps) {
  return (
    <span className="financial-education-button__content">
      <span
        className="financial-education-button__text"
        dangerouslySetInnerHTML={{ __html: text || "" }}
      />
      {icon && !iconLeftBandaid && (
        <span className="financial-education-button__icon">{icon}</span>
      )}
    </span>
  );
}
